import {TableCell, TableHead, TableRow, Typography} from "@mui/material";

export const MyTrendsHeaders = () => {

    const headers = [
        'Sport',
        'ATS W-L',
        'OU W-L',
        'SU W-L',
        'SDQL',
        'Trend Description',
        'Actions'
    ]

    return (
        <TableHead>
            <TableRow sx={{ '& > *': { paddingTop: '4px !important', paddingBottom: '4px !important' }}}>
                {headers.map((header: string, ind: number) => {
                    return (
                        <TableCell align="left" key={ind}>
                            <Typography style={{fontWeight: '600'}} variant="caption">
                                {header}
                            </Typography>
                        </TableCell>
                    )
                })}
            </TableRow>
        </TableHead>
    )
}